@use "colors" as *;

.loginScreen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  color: $grey;
  .loginWrapper {
    background: $white;
    box-shadow: 0 0 30px #00000025;
    text-align: center;
    border-radius: 10px;
    overflow: hidden;
  }
  .loginButton {
    background-color: var(--colors-primary);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    margin: 20px 0;
  }
}
